module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_8019.452e7581.png";